import { Injectable } from "@angular/core";
import { AbstractTransformerService } from "../abstract-transformer.service";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class SampleService extends AbstractTransformerService {
  private _totalRows$ = new BehaviorSubject<number>(0);
  public get totalRows$(): Observable<number> {
    return this._totalRows$.asObservable();
  }

  private _sampleSize$ = new BehaviorSubject<number>(1);
  public get sampleSize$(): Observable<number> {
    return this._sampleSize$.asObservable();
  }

  public get totalRows(): number {
    return this._totalRows$.getValue();
  }
  public set totalRows(count: number) {
    this._totalRows$.next(count);
  }

  public get sampleSize(): number {
    return this._sampleSize$.getValue();
  }
  public set sampleSize(count: number) {
    this._sampleSize$.next(count);
  }

  override reset() {
    super.reset();
    this.totalRows = 0;
  }
}
